<template>
  <span class="editor-nav-link nav-link">
    <router-link :to="`/custom/${id}`" @click.native="$emit('navigated')">
      <div class="middle-ellipsis">
        <div class="start">Custom&nbsp;</div>
        <div class="end">{{ id }}</div>
      </div>
    </router-link>
    <UiIconButton color="secondary" style="color: white" @click="removeCustomText(id)">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:key="'1'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
    </UiIconButton>
  </span>
</template>

<script>
import UiIconButton from "keen-ui/src/UiIconButton.vue";

export default {
  components: {
    UiIconButton,
  },
  props: {
    id: Number,
  },
  methods: {
    removeCustomText(id) {
      this.$store.commit("removeCustomText", { id });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/dark";

.editor-nav-link {
  margin: 0 3px;
  display: inline-flex;
  align-items: center;
  $button-size: 20px;
  min-width: 60px;

  a {
    flex: unset;
    min-width: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .ui-icon-button {
    flex: 0 0 auto;
  }

  .ui-icon-button {
    height: $button-size;
    width: $button-size;
    &:hover {
      // background: rgba($accent, 0.85);
      @include dark;
    }
    svg {
      height: $button-size;
      width: $button-size;
    }
  }
}

.middle-ellipsis {
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content:flex-start;
}
.start {
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  flex-shrink: 1;
}
.end {
  white-space:nowrap;
  flex-basis:content;
  flex-grow: 0;
  flex-shrink: 0;
}
</style>
